import React, { memo } from 'react'
import { useParams } from 'react-router-dom'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { MarketplaceLoadDetails } from 'apps/fleet-planner/components/marketplace/MarketplaceLoadDetails'
import MarketplacePage from '../marketplace/MarketplacePage'

export interface IBookLoadsPageProps {}

const BookLoadsPage = memo<IBookLoadsPageProps>(() => {
  const { isMobile } = useBreakpointContext()
  const { shipmentId } = useParams<{ shipmentId: string }>()

  return <>{isMobile && shipmentId ? <MarketplaceLoadDetails /> : <MarketplacePage />}</>
})

export default BookLoadsPage
